module.exports = __webpack_public_path__ + "img/jamie.72ac095f.jpg";